import { useCallback, useEffect, useState } from "react";

const FAV_KEY = "felacoo.chart.favTools";
const LAST_KEY = "felacoo.chart.lastTool";
const read = (k, fb) => { try { const v = JSON.parse(localStorage.getItem(k) || "null"); return v ?? fb; } catch { return fb; } };

// Favourite tools (star bar) + last-used tool per category, persisted in localStorage.
export function useToolFavorites() {
  const [favorites, setFavorites] = useState(() => read(FAV_KEY, ["trend", "hline", "rect", "fib", "measure", "bosmark"]));
  const [lastUsed, setLastUsed] = useState(() => read(LAST_KEY, {}));
  useEffect(() => { localStorage.setItem(FAV_KEY, JSON.stringify(favorites)); }, [favorites]);
  useEffect(() => { localStorage.setItem(LAST_KEY, JSON.stringify(lastUsed)); }, [lastUsed]);
  const toggleFavorite = useCallback((id) => setFavorites((f) => (f.includes(id) ? f.filter((x) => x !== id) : [...f, id])), []);
  const remember = useCallback((categoryId, toolId) => setLastUsed((m) => (m[categoryId] === toolId ? m : { ...m, [categoryId]: toolId })), []);
  return { favorites, toggleFavorite, lastUsed, remember };
}
